import { Component } from '@angular/core';
import { isEmbedded } from '@mnz-shared/shared.constants';

@Component({
  selector: 'app-login-header',
  templateUrl: './login-header.component.html',
  styleUrls: ['./login-header.component.scss']
})
export class LoginHeaderComponent {
  public isEmbedded(): boolean {
    return isEmbedded();
  }
}
